<template>
  <div class="feed-card feed__message-block messagerie-item truck-message guided-depollution">
    <div class="d-flex position-relative">
      <span class="v-line"></span>
      <span class="circle-step icon flex-shrink-0">
        <CommentDots />
      </span>

      <div class="content">
        <h3 v-if="userActivity.title_html" v-html="userActivity.title_html"></h3>

        <div v-if="imageUrl" class="mb-3 d-flex justify-content-center">
          <img
            :src="imageUrl"
            :alt="$t('guided_depollution.vehicle_photo_alt')"
            class="img-fluid rounded guided-vehicle-image"
          />
        </div>

        {{ text }}

        <TimeInfos :userActivity="userActivity"/>
      </div>
    </div>
  </div>
</template>

<script>
  import TimeInfos from '@components/utils/TimeInfos.vue';
  import CommentDots from '@images/CommentDots.vue';

  export default {
    props: {
      userActivity: Object
    },
    components: {
      TimeInfos,
      CommentDots
    },
    computed: {
      text() {
        return this.userActivity.data.text;
      },
      imageUrl() {
        return this.userActivity.data.image_url;
      }
    }
  };
</script>

<style scoped>
.guided-vehicle-image {
  max-height: 250px;
  object-fit: cover;
}
</style>
